const ROUTES = {
    LANDING : '/',
    HOME : '/home',
    DASHBOARD: '/dashboard',
    PROFILE: '/profile',
    LOGIN: '/auth/login',
    ABOUT: '/about',
    REGISTER: '/auth/register',
    BOOKING: '/booking',
    DETAIL: '/detail',
    PAYMENT_SUCCESS: '/payment-success',
    PAYMENT_FAILED: '/payment-failed',
    DEMO_FINAL: '/demo-final',
}

export default ROUTES